module.exports = __webpack_public_path__ + "img/lx-img2.22418f8d.png";